<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          outlined
          class="pa-2 pt-0"
          tile
        >
          <v-list-item tow-line>
            <v-list-item-content>
              <div class="overline mb-4 subtitle-1">
                {{ info.debitAmount | currency }}
              </div>

              <v-list-item-title class=" headline mb-1 subtitle-2">
                <v-icon>mdi-arrow-down-bold</v-icon> Debit Amount
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          outlined
          class="pa-2 pt-0"
          tile
        >
          <v-list-item tow-line>
            <v-list-item-content>
              <div class="overline mb-4 subtitle-1">
                {{ info.creditAmount | currency }}
              </div>

              <v-list-item-title class=" headline mb-1 subtitle-2">
                <v-icon>mdi-arrow-up-bold</v-icon> Credit Amount
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          outlined
          class="pa-2 pt-0"
          tile
        >
          <v-list-item tow-line>
            <v-list-item-content>
              <div class="overline mb-4 subtitle-1">
                {{ info.pendingAmount | currency }}
              </div>

              <v-list-item-title class="headline mb-1 subtitle-2">
                <v-icon>mdi-timetable</v-icon> Pending Amount
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-text>
            <bar-chart
              height="25"
              :data="paidUnpaid"
            />
            <pie-chart
              height="25"
              :data="paidUnpaid"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card outlined>
          <v-card-text>
            <bar-chart
              height="25"
              :data="debitCredit"
            />
            <pie-chart
              height="25"
              :colors="['red', 'green']"
              :data="debitCredit"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: {},
    };
  },
  computed: {
    paidUnpaid() {
      return [
        ["Paid", this.$data.info.paidPayments],
        ["Unpaid", this.$data.info.unPaidPayments],
      ];
    },
    debitCredit() {
      return [
        ["Debit", this.$data.info.debitPayments],
        ["Credit", this.$data.info.creditPayments],
      ];
    },
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    getFromApi() {
      window.axios.get("/payments-overall").then((response) => {
        this.$data.info = response.data;
      });
    },
  },
};
</script>
